// extracted by mini-css-extract-plugin
module.exports = {"article":"article_article__kaKS0"};